<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="厂区">
              <a-input placeholder="请输入厂区" v-model="queryParam.factoryName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="区域">
              <a-input placeholder="请输入区域" v-model="queryParam.areaName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="楼栋">
              <a-input placeholder="请输入楼栋" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" v-has="'preBuild:search'" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" v-has="'preBuild:reset'" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" v-has="'preBuild:add'" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('pre_building')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
         <template slot="status" slot-scope="text, record">
          <j-switch v-model="record.status" @change="statusChange(record)"  ></j-switch>
        </template>
        
        <span slot="action" slot-scope="text, record">
          <a v-has="'preBuild:edit'" @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'preBuild:detail'">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-has="'preBuild:delete'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <pre-building-modal ref="modalForm" @ok="modalFormOk"></pre-building-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import PreBuildingModal from './modules/PreBuildingModal'
  import { httpAction, getAction } from '@/api/manage'
  
  export default {
    name: 'PreBuildingList',
    mixins:[JeecgListMixin, mixinDevice,JEditableTableModelMixin],
    components: {
      PreBuildingModal
    },
    data () {
      return {
        description: 'pre_building管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'省份',
            align:"center",
            dataIndex: 'provinceName'
          },
          {
            title:'城市',
            align:"center",
            dataIndex: 'cityName'
          },
          {
            title:'厂区',
            align:"center",
            dataIndex: 'factoryName'
          },
          {
            title:'区域',
            align:"center",
            dataIndex: 'areaName'
          },
          {
            title:'楼栋编码',
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'楼栋名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'负责人姓名',
            align:"center",
            dataIndex: 'principal'
          },
          {
            title:'负责人联系电话',
            align:"center",
            dataIndex: 'telephone'
          },
          {
            title:'负责人邮箱',
            align:"center",
            dataIndex: 'email'
          },
         /* {
            title:'是否启用',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'status'}
          }, */
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/prevent/building/prebuildings",
          delete: "/prevent/building/preareaDeleteById",
          deleteBatch: "/prevent/building/prebuilding/batch",
          exportXlsUrl: "/prevent/building/export-xls",
          importExcelUrl: "prevent/building/import-excel",
          edit: "/prevent/building/prebuildingState",
        },
        model:{},
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      statusChange(record)
      {
        this.model = Object.assign({}, record); 
        httpAction(this.url.edit,this.model,'put').then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      initDictConfig(){
        },
      },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
